import axios from 'axios';
import { getToken, refreshToken } from './auth';
import { getAuth } from 'firebase/auth';

// Fixed API URL - this should point to your backend URL
const API_URL = process.env.REACT_APP_API_URL || 'https://spending-tracker-api-fnlo.onrender.com/api';

console.log('API URL configured as:', API_URL); // Debugging line to verify the URL

const axiosInstance = axios.create({
    baseURL: API_URL, // This should be your Render backend URL
});

// Add a request interceptor for detailed logging
axiosInstance.interceptors.request.use(config => {
    console.log('FULL AXIOS REQUEST:');
    console.log('URL:', config.url);
    console.log('BASE URL:', config.baseURL);
    console.log('METHOD:', config.method);
    console.log('FULL CONFIG:', JSON.stringify(config, null, 2));
    return config;
}, error => {
    return Promise.reject(error);
});

// Add a request interceptor for token handling
axiosInstance.interceptors.request.use(
    async (config) => {
        let token = getToken();
        
        // Log the first part of the token for debugging
        console.log("Token before request:", token ? token.substring(0, 20) + "..." : "No token");
        
        // If no token is found, try to refresh it
        if (!token) {
            console.log("No token found, attempting to refresh...");
            token = await refreshToken();
        }
        
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
            // Log the full header to see exactly what's being sent
            console.log("Auth header:", config.headers.Authorization.substring(0, 27) + "...");
        } else {
            console.warn(`Request to ${config.url} without token!`);
        }
        
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add a response interceptor to handle 401 errors
axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;
        
        // If error is 401 and we haven't tried to refresh the token yet
        if (error.response && error.response.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            console.log("401 error, trying to refresh token...");
            
            // Try to refresh the token
            const newToken = await refreshToken();
            
            if (newToken) {
                console.log("Token refreshed, retrying request");
                originalRequest.headers.Authorization = `Bearer ${newToken}`;
                return axiosInstance(originalRequest);
            }
        }
        
        return Promise.reject(error);
    }
);

export const verifyToken = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
        console.warn("No token found when making API call");
        // Try to refresh it from Firebase
        const auth = getAuth();
        const user = auth.currentUser;
        if (user) {
            const newToken = await user.getIdToken(true);
            localStorage.setItem('token', newToken);
            axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
            console.log("Token refreshed before API call");
            return true;
        }
        return false;
    }
    return true;
};

export default axiosInstance; 